 
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import backgroundImage from '../assets/images/05.jpg';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../Context/AuthProvider';


function SideProject() {
    const { id } = useParams();

    const {user,isAuth} = useContext(AuthContext) 
     
  

  return (
    <>


    {/* Advanced filter responsive toggler START */}
    <div className="d-flex align-items-center d-lg-none">
        <button className="border-0 bg-transparent" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSideNavbar" aria-controls="offcanvasSideNavbar">
            <span className="btn btn-primary"><i className="fa-solid fa-sliders-h" /></span>
            <span className="h6 mb-0 fw-bold d-lg-none ms-2">My profile</span>
        </button>
    </div>
    {/* Advanced filter responsive toggler END */}
    {/* Navbar START*/}
    <nav className="navbar navbar-expand-lg mx-0">
        <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasSideNavbar">
            {/* Offcanvas header */}
            <div className="offcanvas-header">
                <button type="button" className="btn-close text-reset ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>
            {/* Offcanvas body */}
            <div className="offcanvas-body d-block px-2 px-lg-0">
                {/* Card START */}
                <div className="card overflow-hidden">
                    {/* Cover image */}
                    <div className="h-50px" style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
                    {/* Card body START */}
                    <div className="card-body pt-0">
                        <div className="text-center">
                            {/* Avatar */}
                            <div className="avatar avatar-lg mt-n5 mb-3">
                                        <a href="#!"><img className="avatar-img rounded border border-white border-3" src={user.profilePicture} alt /></a>
                                    </div>
                            {/* Info */}
                            <h5 className="mb-2"> <a href="#!">{user.username} </a> </h5>
                            {/* <small ><a target="_blank" href={user && user.link}>{user.link}</a></small> */}
                            <div className="hstack gap-2 gap-xl-3 justify-content-center mt-4">
                                {/* User stat item */}
                                <div>
                                    <h6 className="mb-0">{user && user.documents && user.documents.length}</h6>
                                    <small>Post</small>
                                </div>
                                {/* Divider */}
                                <div className="vr" />
                                {/* User stat item */}
                                <div>
                                    <h6 className="mb-0">{user && user.documents && user.connections.length}</h6>
                                    <small>Followers</small>
                                </div>
                                {/* Divider */}


                            </div>

                        </div>
                        <hr />

                        <ul className="nav nav-link-secondary flex-column fw-bold gap-2">
                            <li className="nav-item ">
                                <a className="nav-link active" data-bs-toggle="tab" href="#tab-1"> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/home-outline-filled.svg" alt /><span>Details </span></a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#tab-2"> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/calendar-outline-filled.svg" alt /><span>Tasks </span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#tab-3"> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/person-outline-filled.svg" alt /><span>Members </span></a>
                            </li>
                           
                            {/* <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#tab-4"> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/chat-outline-filled.svg" alt /><span>WorkGroups </span></a>
                            </li> */}
                            {/* <li className="nav-item">
                                <a className="nav-link" href="#tab-2"> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/notification-outlined-filled.svg" alt /><span>Notifications </span></a>
                            </li> */}

                        </ul>
                        {/* Side Nav END */}
                    </div>
                    {/* Card body END */}
                    {/* Card footer */}
                   
                </div>
                {/* Card END */}
              
                 
                 
            </div>
        </div>
    </nav>
    {/* Navbar END*/}



</>
  )
}

export default SideProject